import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
 
@Injectable()
export class InterCommService {
    checkIfCounsellorAssigned: Subject<string>;
    constructor() {
        this.checkIfCounsellorAssigned = new Subject<any>(); 
    }
}